import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  useMediaQuery,
  useTheme
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import PDFViewer from '../../PDFViewer';

function PreviewPdfDialog({
    openDialogPDF,
    setOpenDialogPDF,
    handleDownloadPdf,
    showPdf
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function onCloseDialog () {
    setOpenDialogPDF(false)
  }

  return (
    <Dialog
      open={openDialogPDF}
      onClose={onCloseDialog}
      maxWidth="xl"
      sx={{ fontSize: '1rem' }}
      fullWidth={isMobile}
    >
        <DialogTitle sx={{ fontSize: '1rem' }} style={style.dialogColor}>
          Preview PDF
        </DialogTitle>
        <DialogContent style={style.dialogContent}>
          <PDFViewer pdfUrl={showPdf} />
        </DialogContent>
        <DialogActions style={style.dialogColor}>
          <Button onClick={ handleDownloadPdf }>
            <DownloadIcon/>
            ดาวน์โหลด
          </Button>
          <Button color='error' onClick={onCloseDialog}>
            ปิด
          </Button>
        </DialogActions>
    </Dialog>
  )
}

export default PreviewPdfDialog

const style = {
  dialogContent: {
    overflowX: "auto",
    alignSelf: "center",
    backgroundColor: '#9ca3af',
    padding: 0
  },
  dialogColor: {
    backgroundColor: '#fafafa',
  }
}
